import { useEffect, useRef, useState } from 'react';
import { formatTimestampToRemainTime } from '../utils';
export default function useInterval(discountEndTime) {
  const [remainDiscountTime, setRemainDsicountTime] = useState(
    discountEndTime - new Date().getTime(),
  );
  const timeRef = useRef();
  useEffect(() => {
    if (timeRef.current) {
      return;
    }
    timeRef.current = setTimeout(() => {
      setRemainDsicountTime(v => v - 1000);
    }, 1000);
    return function cleanUp() {
      clearTimeout(timeRef.current);
      timeRef.current = null;
    };
  }, [remainDiscountTime]);

  if (remainDiscountTime <= 0) {
    return null;
  }

  return formatTimestampToRemainTime(remainDiscountTime);
}
